import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IClose = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill={props.color ?? '#37474F'}
          >
            <path
              d="M16 14.0507L9.87733 7.98733L15.9387 1.87133L14.0507 0L7.99067 6.11933L1.87333 0.0606667L0 1.934L6.124 8.004L0.0606667 14.1267L1.934 16L8.00867 9.872L14.1287 15.9387L16 14.0507Z"
              fill={props.color ?? '#37474F'}
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IClose;
